{register} = require 'src/js/infrastructure/setup-registry'
{getByName} = require 'src/coffee/controls/map'

{MyRTKBasesLiveViewPlugin} = require 'src/coffee/areas/my-rtk-base/evaluation/plugins/bases-live-view-plugin'
{MyRTKBasesLiveViewTooltipPlugin} = require 'src/coffee/areas/my-rtk-base/evaluation/plugins/bases-live-view-tooltip-plugin'

setup = ($ctx, promise) ->
    layerName = $ctx.find('#update-positions').data 'layer-name'
    map = getByName 'bases-live-view', $ctx
    map.registerPlugin new MyRTKBasesLiveViewPlugin($ctx, layerName, promise)
    map.registerPlugin new MyRTKBasesLiveViewTooltipPlugin($ctx, layerName)

register 'App.MyRTKBase.Evaluation.BasesLiveView.Setup', setup